





















































































































































































import {
  BSidebar,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Entreprise } from "@/api/models/adherents/adherent";
import { PtfBeneficiaireBeneficiaireCreate } from "@/api/models/ptfBeneficiaire/Beneficiaire";

// Règle de validation personnalisée pour le téléphone
extend('phone', {
  validate: (value: string) => {
    if (!value) return true; 
    return /^0[1-9]\d{8}$/.test(value);
  },
  message: 'Le numéro de téléphone doit être un numéro valide (10 chiffres)'
});

@Component({
  components: {
    BSidebar,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
  },
  name: "create-beneficiaire",
})
export default class CreateBeneficiaire extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewBeneficiaireSidebarActive!: boolean;

  loading = false;
  required = required;

  newBeneficiaire: PtfBeneficiaireBeneficiaireCreate = {
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    entrepriseId: "",
    numeroDossier: "",
    sendCreatePasswordEmail: undefined
  };

  entreprises: PaginatedList<Entreprise> = new PaginatedList<Entreprise>();

  resetForm() {
    this.newBeneficiaire = {
      nom: "",
      prenom: "",
      email: "",
      telephone: "",
      entrepriseId: "",
      numeroDossier: "",
      sendCreatePasswordEmail: undefined
    };
  }

  handleEmailCheckbox(value: boolean) {
    this.newBeneficiaire.sendCreatePasswordEmail = value;
  }

  async created() {
    await this.searchEntreprises(null);
  }

  async searchEntreprises(params: any) {
    await this.$http.myressif.entreprises
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        undefined,
        undefined,
        params?.search ?? "",
        undefined,
        undefined,
        undefined,
        ['ADHERENT'], // Ne récupérer que les adhérents,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        true
      )
      .then((response: PaginatedList<Entreprise>) => {
        if (!params || params.pageNumber === 1) {
          this.entreprises = response;
        } else {
          this.entreprises.items = [...this.entreprises.items, ...response.items];
          this.entreprises.totalCount = response.totalCount;
        }
      });
  }

  async submit() {
    this.loading = true;
    await this.$http.ptfBeneficiaire.beneficiaires
      .create(this.newBeneficiaire)
      .then(
        async () => {
          successAlert.fire({
            title: "Création d'un bénéficiaire",
            text: "Bénéficiaire créé avec succès",
          });
          this.$emit("refetch-data");
          this.$emit("update:is-add-new-beneficiaire-sidebar-active", false);
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.loading = false;
      });
  }
}
